<div class="results-table">
  <table class="table">
    <thead>
      @if (preHeaders && preHeaders.length) {
        <tr class="pre-header-row">
          @for (preHeader of preHeaders; track preHeader) {
            <th class="sortable-header" [colSpan]="preHeader.span">{{ preHeader.title }}</th>
          }
          @if (isCollapsible) {
            <th></th>
          }
        </tr>
      }
      <tr>
        @for (header of headers; track header) {
          <th class="sortable-header">{{ header.title }}</th>
        }
        @if (isCollapsible) {
          <th></th>
        }
      </tr>
    </thead>
    @if (!isDataBlank) {
      <tbody id="test">
        @for (cell of body; track cell; let i = $index) {
          <tr>
            @for (header of headers; track header) {
              <td
                id="emt-table-body-row"
              [ngClass]="{
                'collapsable-cell': toggledCell === i,
                link: cell | validateTableCellClass: header
              }"
                (click)="onCellClicked(header, cell)"
                >
                {{ cell | validateTableCellInput: header }}
              </td>
            }
            @if (isCollapsible) {
              @if (cell | validateTableCellCollapsibility: isCollapsible:collapsibleKey) {
                <td
                  [ngClass]="toggledCell === i && 'collapsable-cell'"
                  >
                  <emt-delta-icon class="icon-arrow" [flip]="toggledCell === i" iconName="icon-arrow" (click)="toggleCell(i)"></emt-delta-icon>
                </td>
              } @else {
                <td id="filler-cell"></td>
              }
            }
          </tr>
          @if (toggledCell === i) {
            @for (dropdownCell of cell[collapsibleKey]; track dropdownCell) {
              <tr class="collpasable-row">
                @for (header of headers; track header) {
                  <td [ngClass]="{ 'collapsable-cell': toggledCell === i }">
                    {{ dropdownCell | validateTableCellInput: header }}
                  </td>
                }
                <td class="collapsable-cell"></td>
              </tr>
            }
          }
        }
      </tbody>
    }
  </table>
  @if (isDataBlank && !customTableMsg) {
    <p class="no-data-msg" id="no-data-available-msg">NO DATA AVAILABLE</p>
  }
  @if (isDataBlank && customTableMsg) {
    <p class="no-data-msg" id="custom-table-msg">{{ customTableMsg }}</p>
  }
</div>
